<template>
  <vs-popup class="customer-site-create-popup"
            background-color-popup="danger"
            background-color="danger"
            title="CREDIT CHECK"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card  no-shadow>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-alert active="true" class="w-full h-auto" color="danger" icon-pack="feather" icon="icon-info">
            <span>Sorry, but you don't have <strong>enough available credit</strong> to order this amount. Please choose from one of the following 3 options;</span>
          </vs-alert>
        </div>
      </div>


      <div
        class="flex justify-between text-center mt-8">

        <div @click="onClickPayOutstandingInvoice" class="shadow-lg	 w-1/3 border border-solid d-theme-border-grey-light border p-6 hover:bg-danger hover:text-white rounded-l-lg cursor-pointer">
          <feather-icon icon="InfoIcon" class="p-3 inline-flex rounded-full"></feather-icon>
          <p class="mb-4 text-2xl font-semibold">Pay outstanding invoices</p>
        </div>
        <div @click="onClickIncreaseCreditLimit" class="shadow-lg w-1/3 border border-solid d-theme-border-grey-light border p-6 hover:bg-danger hover:text-white cursor-pointer">
          <feather-icon icon="DollarSignIcon" class="p-3 inline-flex rounded-full"></feather-icon>
          <p class="mb-4 text-2xl font-semibold">Apply for a credit increase</p>
        </div>
        <div @click="onClickClose" class=" shadow-lg w-1/3 border border-solid d-theme-border-grey-light border p-6 hover:bg-danger hover:text-white rounded-r-lg cursor-pointer">
          <feather-icon icon="XIcon" class="p-3 inline-flex rounded-full"></feather-icon>
          <p class="mb-4 text-2xl font-semibold">Reduce order Qty within available credit limit</p>
        </div>
      </div>


    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'


  function initialState() {
    return {
      open: false,
      id: '',
    }
  }

export default {
  name: 'CustomerCreditCheckPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.open = true;
      } catch (error) {

      }
    },
    async onClickIncreaseCreditLimit() {
      this.open = false;
      this.$emit('openCreditLimitRequest')
      // await this.$parent.openCreditLimitRequest()
    },
    async onClickClose() {
      this.open = false;
      this.$emit('onlyRefreshData')
      // await this.$parent.onlyRefreshData()
    },
    async refreshData () {
      this.open = false;
    },
    async onClickPayOutstandingInvoice() {
      this.open = false;
      this.$emit('refreshData')
      // await this.$parent.refreshData()
    }
  },
  components: {
    'v-select': vSelect
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-site-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
